import { useEffect, useState } from "react";

/**
 * Debounces a value and returns it after the specified delay.
 * @param value - value to debounce 
 * @param delay - delay timer (default is 300ms)
 * @returns 
 */
export default function useDebouncedValue<T>(value: T, delay: number = 300): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounced(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debounced;
}